import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function AddTenantNamespaceButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.addNamespace")}</ActionButtonLayout>;

}

export default AddTenantNamespaceButtonLayout;

